import React from 'react';

const Jumbotron = () => {
    return (
        <div 
            className="jumbotron jumbotron-fluid rounded p-5" 
            style={{ backgroundColor: '#106048', marginLeft: '10vw', marginRight: '10vw' }}
        >
            <div className="container text-center text-white">
                <h4 className="display-6 text-light">Join Thousands of Brokers Already Simplifying Their Businesses with Aasaann</h4>
                <p className="lead text-light">
                Managing the vegetable market business has never been easier. With Aasaann, handle sales, purchases, payments, and reports, all in one platform. Take control and see how easy it is to stay organized and efficient.
                </p>
                <h3 className="display-8 text-light mt-5">Start using Aasaann today and experience the future of vegetable market management.</h3>
            </div>
        </div>
    );
};

export default Jumbotron;
